import { Component, Input } from '@angular/core';
import { HttpService } from '../../../../services/dataAccess.service';
import { CoreService } from '../../../../services/core.service';
import { TDOPersonne, PropertyData, HtmlBase, QueovalItem, BObjectModel, BObjectSummary, Result, TDOClient, MainSearchRequest, InnerJoinRelation, SendMailModel, Recipient, QueovalDik } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../toast';
import { GoCardlessBillingRequestFlowResponse } from '../../../../models/gocardless/gocardless.models';
import { ModelMail } from '../../../../models/model-email';

@Component({
  selector: 'q-mandat-gocardless',
  templateUrl: './mandat-gocardless.component.html',
  styleUrls: ['./mandat-gocardless.component.css']
})

export class MandatGocardlessComponent extends BaseAddOnComponent {

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('input') input: PropertyData;
  @Input('model') set SetModel(value: BObjectModel) { this.model = value; }

  private urlForm: string = '';

  private model: BObjectModel;
  public loading: boolean = false;
  public newModel: boolean = false;
  public listeBo: string[] = [
    'BO_CSOC|REL_BO_CENT_BO_CSOC|F',
    'BO_DIRIGEANT|REL_BO_CSOC_BO_DIRIGEANT|F',
    'BO_CONTACT|REL_BO_CSOC_BO_CONTACT|F',
    'BO_COLLABO|REL_BO_PAR_BO_COLLABO|F'
  ];
  public mailModel: SendMailModel;
  // #region CONSTRUCTEUR
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal,
    private toast: ToastService,
  ) { super(); }
  // #endregion

  // #endregion
  public OpenModal(content: any) {
    this.loading = true;
    const selectContactDatas: MainSearchRequest = new MainSearchRequest();
    selectContactDatas.Select = 'd.*';
    selectContactDatas.From = TDOPersonne.TableName;
    const innerJoinContact: InnerJoinRelation = new InnerJoinRelation();
    innerJoinContact.IdDonnee = this.model.IdDonneeFils;
    innerJoinContact.Origin = 'PERE';
    innerJoinContact.Relation = 'REL_BO_CSOC_BO_CONTACT'

    const innerJoinDirigeant: InnerJoinRelation = new InnerJoinRelation();
    innerJoinDirigeant.IdDonnee = this.model.IdDonneeFils;
    innerJoinDirigeant.Origin = 'PERE';
    innerJoinDirigeant.Relation = 'REL_BO_CSOC_BO_DIRIGEANT'
    selectContactDatas.InnerJoinTDOLien = [innerJoinDirigeant, innerJoinContact];

    this.http.postHttp<Result<any[]>>(`${this.indParam.AppParams.apiUrl}api/mainsearch/datas`, selectContactDatas).subscribe((response: Result<any[]>) => {
      this.mailModel = new SendMailModel();
      this.mailModel.RecipientList = response.Value.map(contact => {
        const recipient = new Recipient();

        const nom: string = contact[TDOPersonne.Cols.strNom] ? contact[TDOPersonne.Cols.strNom] : '';
        const prenom: string = contact[TDOPersonne.Cols.strPrenom] ? contact[TDOPersonne.Cols.strPrenom] : '';
        recipient.Ident = contact.Ident;
        recipient.Mails = [];
        if (contact[TDOPersonne.Cols.strEmail1]) {
          recipient.Mails.push(new QueovalDik(nom + ' ' + prenom, contact[TDOPersonne.Cols.strEmail1]));
        }

        recipient.Tels = [];
        if (contact[TDOPersonne.Cols.strNumTelBureau]) {
          recipient.Tels.push(new QueovalDik(nom + ' ' + prenom, contact[TDOPersonne.Cols.strNumTelBureau]));
        }
        if (contact[TDOPersonne.Cols.strNumTelDomicile]) {
          recipient.Tels.push(new QueovalDik(nom + ' ' + prenom, contact[TDOPersonne.Cols.strNumTelDomicile]));
        }
        if (contact[TDOPersonne.Cols.strNumTelMobile]) {
          recipient.Tels.push(new QueovalDik(nom + ' ' + prenom, contact[TDOPersonne.Cols.strNumTelMobile]));
        }
        recipient.TypeRecipient = 'CONTACT';
        recipient.Value = nom + ' ' + (prenom ? (prenom as string).toUpperCase()[0] : '');
        return recipient;
      });

      //const selectClientDatas: MainSearchRequest = new MainSearchRequest();
      //selectClientDatas.Select = 'd.' + TDOClient.Cols.strLienMandatGoCardless;
      //selectClientDatas.From = TDOClient.TableName;
      //selectClientDatas.Where = 'd.Ident = ' + this.model.IdDonneeFils;

      //this.http.postHttp<Result<any[]>>(`${this.indParam.AppParams.apiUrl}api/mainsearch/datas`, selectClientDatas).subscribe((responseClient: Result<any[]>) => {

      //  if (responseClient.Value.length == 1) {
      //    if (responseClient.Value[0][TDOClient.Cols.strLienMandatGoCardless]) {
      //      this.urlForm = responseClient.Value[0][TDOClient.Cols.strLienMandatGoCardless];
      //    }
      //  }
      //  if (!this.urlForm) {
      //    this.http.getHttp<Result<GoCardlessBillingRequestFlowResponse>>(`${this.indParam.AppParams.UrlPaymentWS}api/gocardless/create/billing/${this.model.IdDonneeFils}`).subscribe((response: Result<GoCardlessBillingRequestFlowResponse>) => {
      //      this.urlForm = response.Value.AuthorisationUrl;
      //      const summaryMandateLink: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
      //        return el.ColumnName.toLowerCase() == TDOClient.Cols.strLienMandatGoCardless.toLowerCase();
      //      });
      //      if (summaryMandateLink && summaryMandateLink.length == 1) {
      //        const prop: PropertyData = this.model.Body.SelectedGroupsList[summaryMandateLink[0].IndexGroupsList].DataList[summaryMandateLink[0].IndexDataList];
      //        prop.MainElementList[0].Value = response.Value.AuthorisationUrl;
      //      }

      //      const summaryMandate: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
      //        return el.ColumnName.toLowerCase() == TDOClient.Cols.strMandatGoCardless.toLowerCase();
      //      });
      //      if (summaryMandate && summaryMandate.length == 1) {
      //        const prop: PropertyData = this.model.Body.SelectedGroupsList[summaryMandate[0].IndexGroupsList].DataList[summaryMandate[0].IndexDataList];
      //        prop.MainElementList[0].Value = response.Value.BillingRequestId;
      //      }

      //      const summaryClient: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
      //        return el.ColumnName.toLowerCase() == TDOClient.Cols.strClientGoCardless.toLowerCase();
      //      });
      //      if (summaryClient && summaryClient.length == 1) {
      //        const prop: PropertyData = this.model.Body.SelectedGroupsList[summaryClient[0].IndexGroupsList].DataList[summaryClient[0].IndexDataList];
      //        prop.MainElementList[0].Value = response.Value.CustomerBankAccount;
      //      }
      //      this.loading = false;
      //      this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-mandat-gocardless qmodalover' }).result.then(() => {

      //      });

      //    });
      //  }
      //  else {
      //    this.loading = false;
      //    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-mandat-gocardless qmodalover' }).result.then(() => {
      //    });
      //  }
      //});
    });



  }
  public copyToClipboard(urlForm: string) {
    navigator.clipboard.writeText(urlForm);
    this.toast.showInfoToast(`Le lien a été copié dans le presse-papiers`)
  }

  public OnModelMailSaved(value: ModelMail): void {
    this.newModel = false;
  }
}
